export class CommonModelResponse<T> {
  public data: T;
  public error: string;
  public value: string;
  public access_token: string;
  public access_code: string;
  public dataList: Array<T>;
  public refresh_token: string;
  public bookingDate: Date;
}
